/* eslint-disable no-unused-vars */
import React, { useContext } from 'react';
import { selectIsLoggedIn } from 'store/Sesion/selectors';
import { selectLocation } from 'store/Router/selectors';
import { useSelector } from 'react-redux';
import Searcher from 'Common/Components/Searcher';
import WorkspaceSelector from './WorkspaceMenuSelector';
import User from './User/userContainer';
import ProcessingQueueButton from './ProcessingQueueButton';
import { Header, Separator, SwitchContainer, Wrapper } from './styled';
import VulnsCounter from './VulnsCounter';
import AssetSelector from './AssetSelector';
import Title from './Title';
import HomeButton from './HomeButton';
import HostModalCreate from '../HostModalCreate';
import Switch from 'react-switch';
import colors from 'Styles/colors';
import { ThemeContext } from 'Context';

const NavMenuContext = () => {
  const loggedIn = useSelector((state) => selectIsLoggedIn(state));
  const location = useSelector((state) => selectLocation(state));
  const isInsideWs = location.pathname.startsWith('/feed') ||
   location.pathname.startsWith('/host/') ||
   location.pathname.startsWith('/manage') ||
   location.pathname.startsWith('/service/') ||
   location.pathname.startsWith('/credentials');
  const isOutsideWs = location.pathname.startsWith('/workspaces') ||
  location.pathname.startsWith('/vulnerabilities') ||
  location.pathname.startsWith('/hosts') ||
  location.pathname.startsWith('/services');

  const customPadding = location.pathname === '/automation/agents';

  const { toggleTheme, theme } = useContext(ThemeContext);

  return loggedIn && (
    <Header customPadding={ customPadding }>
      <Title />
      { isInsideWs &&
        <>
          <HomeButton />
          <Separator />
          <WorkspaceSelector />
        </>
      }
      <AssetSelector />
      <VulnsCounter />
      <Searcher />
      <HostModalCreate />
      <Wrapper isOutsideWs={ isOutsideWs }>
        {/* <SwitchContainer>
          <Switch
            checked={ theme === 'light' }
            onChange={ toggleTheme }
            onColor={ colors.yellow1 }
            offColor={ colors.dark7 }
            onHandleColor={ colors.tangerine }
            offHandleColor={ colors.dark7 }
            boxShadow="0 0 4px 0 rgba(83, 83, 83, 0.5)"
            activeBoxShadow=""
            height={ 14 }
            width={ 39 }
            handleDiameter={ 21 }
            uncheckedIcon={ false }
            checkedIcon={ false }
          />
        </SwitchContainer> */}
        <ProcessingQueueButton />
        <User />
      </Wrapper>
    </Header>
  );
};

export default NavMenuContext;
